module.exports = __webpack_public_path__ + "static/media/address.c7dcb9a7.svg";